import React, {useCallback, useRef} from 'react';
import { isAppleDevice, isSafariBrowser } from '../../shared/helpers';

import styles from './PopupBookmark.module.scss';
import InstructionsMobileIos from '../../assets/images/bookmark_mobile_ios.png';
import InstructionsDesktopIos from '../../assets/images/bookmark_desktop_ios.png';
import InstructionsMobileAnd from '../../assets/images/bookmark_mobile_and.png';
import InstructionsDesktopAnd from '../../assets/images/bookmark_desktop_and.png';

import LoadableImage from "../LoadableImage/LoadableImage";
import useClickOutside from "../../hooks/useClickOutside";

const PopupBookmark = ({ windowSize, closePopupBookmark }) => {
    const isFirstRender = useRef(true);

    let currentBookmarkImg = InstructionsMobileAnd;
    if (windowSize.isMobileView) {
        if (isAppleDevice()) {
            currentBookmarkImg = InstructionsMobileIos;
        }
    } else {
        currentBookmarkImg = InstructionsDesktopAnd;
        if (isSafariBrowser()) {
            currentBookmarkImg = InstructionsDesktopIos;
        }
    }

    const wrapperRef = useClickOutside(useCallback(() => {
        if (!isFirstRender.current) {
            closePopupBookmark();
        } else {
            isFirstRender.current = false;
        }
    }, [closePopupBookmark]));

    return (
        <div className={styles.overlay}>
            <div className={styles.wrapper} ref={wrapperRef}>
                <LoadableImage img={currentBookmarkImg} />
                <div className={styles.buttonClose} onClick={() => closePopupBookmark()} />
            </div>
        </div>
    );
};

export default PopupBookmark;